import { Component, OnInit } from "@angular/core";
import {
  FormGroup
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-faqs",
  templateUrl: "./faqs.component.html",
  styleUrls: ["./faqs.component.scss"],
})
export class FaqsComponent implements OnInit {
  form: FormGroup;
  loading = false;
  msgs: any[] = [];

  activeIndex: number | undefined = 0;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly translateService: TranslateService
  ) {

    if (window.location.pathname === '/es') {
      localStorage.setItem('lang', 'es');
      this.translateService.use('es');
    }
  }

  ngOnInit() {
    this.init();
  }

  init() {
    const metaDescription = "With MindMap AI, you can easily create mind maps in three ways (from scratch, by inputting a sentence or PDF file). Our artificial intelligence technology ...";
    // Remove old meta description
    const oldMeta = document.querySelector('meta[name="description"]');
    if (oldMeta) {
      oldMeta.remove();
    }
    // Add meta description to header
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = metaDescription;
    document.getElementsByTagName('head')[0].appendChild(meta);
  }

  setLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
    this.translateService.use(lang);
    window.location.reload();
  }


  activeIndexChange(index: number) {
    this.activeIndex = index
  }


}
